import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ORDER_ACTIONS } from '@order/actions/order-actions';
import { OrderInsightsDownloadService } from '@shared/services/file-download/order-insights-download.service';
import {
  ORDER_INSIGHTS_ACTIONS,
  OrderInsightsState,
  orderInsightsSelectors,
} from '@usf/ngrx-order';
import { filter, map, tap, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import { OrderViewMode } from '@usf/ngrx-order';
import { EASY_PRICING_ACTIONS } from '@usf/ngrx-pricing';

@Injectable({
  providedIn: 'root',
})
export class OrderInsightsEffects {
  downloadOrderInsights$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ORDER_ACTIONS.downloadOrderInsights),
        tap(downloadInsightsEvent => {
          this.orderInsightsDownloadService.downloadOrderInsightsFile(
            downloadInsightsEvent,
          );
        }),
      ),
    { dispatch: false },
  );

  loadPmeForOrderInsights$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ORDER_INSIGHTS_ACTIONS.setSelectedOrderViewMode),
      withLatestFrom(
        this.store.select(orderInsightsSelectors.selectOrderInsightsState),
      ),
      filter(
        ([action, orderInsightsState]) =>
          orderInsightsState.selectedOrderViewMode === OrderViewMode.pricing,
      ),
      map(([action, orderInsightsState]) => {
        const payload: any = {
          productNumbers: orderInsightsState.productNumbers,
          fridayPricing: false,
          overrideCache: false,
          feature:
            'Order Insights - ' +
            orderInsightsState.orderSelected.orderHeader.orderId,
        };
        return EASY_PRICING_ACTIONS.loadEasyPricing(payload);
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private orderInsightsDownloadService: OrderInsightsDownloadService,
    private store: Store<OrderInsightsState>,
  ) {}
}
